import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { LivePriceView } from '~/components/live-price-view/LivePriceView';

export const Title = styled.h2`
  ${typographyV2.titleMd};
`;

export const LatestPrice = styled.div`
  font-family: var(--font-roboto-mono);
  font-size: 16px;
  margin-bottom: 8px;

  ${LivePriceView.Styled.LivePriceBox} {
    font-size: 16px;
  }
`;

export const Marker = styled.div`
  width: 10px;
  height: 10px;
  background-color: currentColor;
`;

export const BullishMarker = styled(Marker)`
  background-color: var(--viz-bullish-soft);
`;

export const BearishMarker = styled(Marker)`
  background-color: var(--viz-bearish-soft);
`;

export const ChartWrapper = styled.div`
  height: 100%;
  & svg {
    max-height: 200px;
  }
`;

export const Legend = styled.div`
  display: flex;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  ${typographyV2.bodySm}
  color: var(--text-soft);
`;

export const Label = styled.div`
  ${typographyV2.bodyXs};
  margin-left: 8px;
`;

export const ButtonContainer = styled.div`
  padding: 4px;
  border-radius: 8px;
  border: 1px solid var(--border-soft);
  background-color: var(--surface-default);
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
